import {defineStore} from "pinia";

export const FormDataStore = defineStore("formData", {
    state: () => ({
        error: false,
        formData: {
            clientDetails: {
                bookingType: null,
                questions: [],
            },
            sessionCategory: {
                sessionCategory: null,
            },
            location: {
                location: null,
            },
            therapyRequired: {
                therapy: null,
                therapyOtherDetails: '',
            },
            cancellationPolicy: {
                cancellationPolicy: null,
            },
            privacyPolicy: {
                privacyPolicy: null,
            },
            bookingCalendar: {
                date: null,
                time: null,
            }
        },
    })
})